import HigherOrderStepData from "higherorder/HigherOrderStepData.js";
export default superclass => class extends superclass {
    getJson() {
        return {
            ... this.getParamsJson(),
            macros: this.macros.map(m => m.getJson()),
            algorithmTypes: this.algorithmTypes,
            scriptEffect: this.scriptEffect.getJson(),
            inputModules: this.inputModules.map(x => x.id),
            freeformModules: this.freeformModules.map(x => x.id),
            routings: this.getRoutingJson(),
            matrix: this.matrix.map(
                c => c.map(s => s && s.getJson())),
        };
    }

    fromJson(json) {
        console.log("h=0 fromjson", json);
        let {
            macros,
            routings,
            matrix,
            algorithmTypes,
            scriptEffect,
            inputModules,
            outputModules,
            freeformModules
        } = json;
        this.algorithmTypes = algorithmTypes;
        if (macros) {
            this.loadMacrosJson(macros);
        }

        if (json.parameters) {
            this.fromParamsJson(json);
        }


        if (scriptEffect) {
            this.scriptEffect.fromJson(scriptEffect);
        }

        if (inputModules) {
            this.inputModules = inputModules.map(
                id => this.getModule(id));
        }

        if (freeformModules) {
            this.freeformModules = freeformModules.map(
                id => this.getModule(id));
        }

        if (routings) {
            this.fromRoutingJson(routings);
        }

        for (let i=0; i < matrix.length; i++ ){
            let col = matrix[i];
            for (let j=0; j < col.length; j++ ){
                if (col[j]) {
                    this.matrix[i][j] = new HigherOrderStepData();
                    this.matrix[i][j].fromJson(col[j], this.sequencerEngine);
                    this.steps.push(this.matrix[i][j]);
                }
            }
        }
        this.updateRedux();
    }
}
